import PropTypes from 'prop-types';
import { memo } from 'react';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { GridIcon } from 'foundations-assets';
import PresentationRecord from '../../records/PresentationRecord';
import { getDarkBrandingColor } from '../../utils/color';
import { MAIN_CONTENT_ANCHOR } from '../../lib/constants';
import ViewToolbarLogo from './toolbar/ViewToolbarLogo';
import ViewToolbarDivider from './ViewToolbarDivider';
import ViewActions from './ViewActions';
import { ButtonWithBranding } from '../ButtonWithBranding';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledViewToolbar = styled.div.withConfig({
  displayName: "ViewToolbar__StyledViewToolbar",
  componentId: "sc-1azo64d-0"
})(({
  borderColor,
  theme: _theme
}) => {
  const theme = _theme;
  return {
    borderColor,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingInline: theme.space['1000'],
    blockSize: '60px',
    flexShrink: 0,
    borderBlockEndWidth: theme.borderWidth['100'],
    borderBlockEndStyle: 'solid'
  };
});
const StyledSkipNav = styled.a.withConfig({
  displayName: "ViewToolbar__StyledSkipNav",
  componentId: "sc-1azo64d-1"
})(["position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden;"]);
const ViewToolbar = ({
  presentation,
  meetingLink,
  fetchDownloadLink,
  onPageDrawerToggle
}) => {
  if (!presentation.brandingMetadata) return null;
  const {
    primaryColor,
    secondaryColor,
    logoAltText,
    companyName
  } = presentation.brandingMetadata;
  const brandingColor = getDarkBrandingColor(primaryColor, secondaryColor);
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsxs(StyledViewToolbar, {
      "data-test-id": "view-toolbar",
      borderColor: brandingColor,
      children: [/*#__PURE__*/_jsx(ViewToolbarLogo, {
        logoUrl: presentation.brandingMetadata.logoUrl,
        logoAltText: logoAltText,
        companyName: companyName
      }), /*#__PURE__*/_jsx(StyledSkipNav, {
        onClick: () => {
          const element = document.getElementById(MAIN_CONTENT_ANCHOR);
          if (element) element.focus();
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "a11y.skipToDocument"
        })
      }), /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(ButtonWithBranding, {
          "aria-hidden": "true",
          onClick: onPageDrawerToggle,
          paddingInline: "100",
          marginInline: "200",
          brandingColor: brandingColor,
          hasBorder: false,
          buttonPaddingBlock: "0px",
          buttonPaddingInline: "0px",
          "data-test-id": "page-drawer-toggle-button",
          children: /*#__PURE__*/_jsx(Flex, {
            children: /*#__PURE__*/_jsx(GridIcon, {
              size: "500"
            })
          })
        }), /*#__PURE__*/_jsx(ViewToolbarDivider, {}), /*#__PURE__*/_jsx(ViewActions, {
          brandingColor: brandingColor,
          presentation: presentation,
          fetchDownloadLink: fetchDownloadLink,
          meetingLink: meetingLink
        })]
      })]
    })
  );
};
ViewToolbar.propTypes = {
  presentation: PropTypes.instanceOf(PresentationRecord),
  meetingLink: PropTypes.string,
  fetchDownloadLink: PropTypes.func.isRequired,
  onPageDrawerToggle: PropTypes.func.isRequired
};
export default /*#__PURE__*/memo(ViewToolbar);